module.exports = __webpack_public_path__ + "img/materials_tools_2.dc2086fd.png";